import type { Adventure } from '../../types'

// Pirate Treasure Subtraction - Age 4 - Fun pirate subtraction theme
export const tillyPirateCorrect = [
  "Yo ho ho! That's right, matey!",
  "Arr! You found the answer!",
  "Shiver me timbers! Perfect subtraction!",
  "Aye aye! You're a math pirate!",
  "Treasure found! Well done!",
  "Ha ha! You got it, captain!",
  "Blimey! You're good at this!",
  "Yo ho! Take away like a pro!",
  "Gold doubloons for you! Correct!",
  "Sailing smooth! That's it!"
]

export const tillyPirateWrong = [
  "Arr, not quite! Count the treasure again!",
  "Shiver me timbers! Try once more, matey!",
  "Hoist the sails! Let's subtract again!",
  "Almost, you scurvy dog! Give it another go!",
  "Blimey! Count what's left behind!",
  "Yo ho! Start over with the treasure!",
  "Walk the plank... to the right answer!",
  "Not that one, captain! Try again!",
  "Ahoy! Let's count together!",
  "Keep trying, brave pirate!"
]

export const pirateTreasureAdventure: Adventure = {
  id: 'pirate-treasure',
  title: 'Pirate Treasure',
  theme: 'addition',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 10,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Ahoy, matey! I am Captain Tilly! We found 8 gold coins, but the parrot took 3! How many coins are left?",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Shiver me timbers! Subtraction means taking away! Let us practice taking away treasure on our pirate ship!",
      duration: 4
    },
    choice1: [
      {
        id: 'count',
        label: 'Count gold coins!',
        tillyLine: "Count the gold, matey!",
        nextState: 'quiz-1'
      },
      {
        id: 'chest',
        label: 'Open treasure chest!',
        tillyLine: "Open sesame! Treasure inside!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: 'You have 5 gold coins. The kraken takes 2!',
      tillyPrompt: 'How many coins left? 5 minus 2?',
      options: [
        { id: 'two', label: '2', isCorrect: false },
        { id: 'three', label: '3', isCorrect: true },
        { id: 'four', label: '4', isCorrect: false }
      ],
      num1: 5,
      num2: -2
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Yo ho ho! You are learning fast! Now we have a chest of 10 gems! Let us share them with the crew!",
      duration: 4
    },
    choice2: [
      {
        id: 'share',
        label: 'Share with crew!',
        tillyLine: "Sharing is caring, even for pirates!",
        nextState: 'quiz-2'
      },
      {
        id: 'hide',
        label: 'Hide the gems!',
        tillyLine: "Hide them from other pirates!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '10 shiny gems! You give 4 to the first mate.',
      tillyPrompt: 'How many do you keep? 10 minus 4?',
      options: [
        { id: 'four', label: '4', isCorrect: false },
        { id: 'five', label: '5', isCorrect: false },
        { id: 'six', label: '6', isCorrect: true }
      ],
      num1: 10,
      num2: -4
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Blimey! You have earned your sea legs! Time for the Captain's Challenge! Take away like a true pirate!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'simple-addition',
          question: 'You found 7 pearls. A seagull snatched 3!',
          tillyPrompt: 'How many pearls left? 7 minus 3?',
          options: [
            { id: 'three', label: '3', isCorrect: false },
            { id: 'four', label: '4', isCorrect: true },
            { id: 'five', label: '5', isCorrect: false }
          ],
          num1: 7,
          num2: -3
        } as any,
        {
          id: 'challenge-2',
          type: 'simple-addition',
          question: '9 gold doubloons in your pocket. You spend 5 on a map.',
          tillyPrompt: 'How many left? 9 minus 5?',
          options: [
            { id: 'three', label: '3', isCorrect: false },
            { id: 'four', label: '4', isCorrect: true },
            { id: 'five', label: '5', isCorrect: false }
          ],
          num1: 9,
          num2: -5
        } as any,
        {
          id: 'challenge-3',
          type: 'simple-addition',
          question: 'Captain\'s test: 12 jewels aboard! The crew takes 7.',
          tillyPrompt: 'How many remain? 12 minus 7?',
          options: [
            { id: 'four', label: '4', isCorrect: false },
            { id: 'five', label: '5', isCorrect: true },
            { id: 'six', label: '6', isCorrect: false }
          ],
          num1: 12,
          num2: -7
        } as any
      ]
    },
    reward: {
      tillyLine: "Yo ho ho! You mastered pirate subtraction! You are a true Captain of the Seven Seas!",
      badgeName: 'Pirate Captain',
      badgeIcon: '⚓',
      nextPreview: 'Next time, we will make patterns with shapes!'
    }
  }
}
